import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=1d3e43be&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e43be",
  null
  
)

export default component.exports